import React from 'react';
import BaseButton from '../../components/BaseButton';
// import authNetLogo from '../../assets/auth-net.png';
import visaSecure from '../../assets/visa-secure-50px.png';
import mastercard from '../../assets/mastercard-id-check-50px.png';
import paypal from '../../assets/paypal-50px.jpg';
import styles from './PaymentFooter.module.scss';

export default function PaymentFooter({ text, onPay, disabled, errorText, ...otherProps }) {
  return (
    <div>
      <div className="legal-notice">
        By clicking the button below, you agree to our Terms of Service and Privacy Policy
      </div>

      <div className={styles.imageContainer}>
        <img alt="mastercard" src={mastercard} />
        <img alt="visa-secure" src={visaSecure} />
        <img alt="paypal" src={paypal} />
      </div>

      <hr className="hr" />

      {errorText && (
        <p className="exchange-info" style={{ color: '#ff7d7d' }}>
          {errorText}
        </p>
      )}

      <BaseButton disabled={disabled} onClick={onPay} {...otherProps}>
        {text}
      </BaseButton>
    </div>
  );
}
